<template>
  <div class="inline-flex flex-row gap-0.5" ref="container" :class="[fullWidth && 'w-full']">
    <template v-for="item in items">
      <BaseTextButton
        v-if="(type == 'text' && !item.onlyIcon) || (type == 'mixed' && checkValue(item.value))"
        :icon="item.icon"
        :shape="shape"
        :color="color"
        :size="size"
        :toggle="true"
        :selected="checkValue(item.value)"
        @click="toggle(item.value)"
        :style="{ 'min-width': item.shrink ? 'auto' : calculatedWidth }"
        class=""
        :class="[
          fullWidth && !item.shrink && 'grow basis-0',
          !checkValue(item.value) && 'not-first:rounded-l-sm! not-last:rounded-r-sm!',
        ]"
        >{{ item.label }}</BaseTextButton
      >
      <BaseIconButton
        v-if="type == 'icon' || item.onlyIcon || (type == 'mixed' && !checkValue(item.value))"
        v-tooltip="item.label"
        :icon="item.icon!"
        :shape="shape"
        :color="color"
        :size="size"
        :toggle="true"
        :selected="checkValue(item.value)"
        @click="toggle(item.value)"
        :class="[
          type != 'mixed' && 'min-w-12',
          fullWidth && !item.shrink && 'grow! basis-0!',
          !checkValue(item.value) && 'not-first:rounded-l-sm! not-last:rounded-r-sm!',
        ]"
      />
    </template>
  </div>
</template>
<script lang="ts" setup generic="T">
  import { onMounted, ref, useTemplateRef } from 'vue'
  import type { ConnectedButtonGroupProps } from './button-props'
  import BaseTextButton from './text-button/BaseTextButton.vue'
  import BaseIconButton from './icon-button/BaseIconButton.vue'

  const {
    shape = 'round',
    color = 'filled',
    size = 'S',
    type = 'text',
    fullWidth = false,
    items,
    canHaveNone = false,
  } = defineProps<ConnectedButtonGroupProps<T>>()

  const model = defineModel<T | T[] | null>({ required: true })

  const toggle = (value: T) => {
    if (canHaveNone && model.value === value) {
      if (Array.isArray(model.value)) {
        model.value = []
      } else {
        model.value = null
      }
      return
    }
    if (Array.isArray(model.value)) {
      if (model.value.findIndex((v) => v == value) !== -1) {
        model.value = model.value.filter((v) => v != value)
      } else {
        model.value.push(value)
      }
    } else {
      model.value = value
    }
  }

  const checkValue = (value: T) => {
    if (Array.isArray(model.value)) {
      return model.value.some((v) => JSON.stringify(v) === JSON.stringify(value))
    } else if (
      typeof model.value === 'object' &&
      typeof value === 'object' &&
      model.value !== null &&
      value !== null
    ) {
      return JSON.stringify(model.value) === JSON.stringify(value)
    } else {
      return model.value == value
    }
  }

  const container = useTemplateRef('container')
  const calculatedWidth = ref('auto')

  onMounted(() => {
    let width = 0
    if (container.value) {
      for (const child of container.value.querySelectorAll('button')) {
        if (child.offsetWidth > width) {
          width = child.offsetWidth
        }
      }
      calculatedWidth.value = width + 'px'
    }
  })
</script>
